import {
  businessCollection,
  systemUserCollection,
} from "../../config/collectionsConfig";

export const signIn = (creds) => {
  return (dispatch, getState, { getFirebase }) => {
    try {
      dispatch(StartLoadingAuth());
      const firebase = getFirebase();
      firebase
        .auth()
        .signInWithEmailAndPassword(creds.email, creds.password)
        .then((value) => {
          dispatch({ type: "SIGN_IN" });
        })
        .catch((err) => {
          dispatch({ type: "SIGN_IN_ERROR", payload: err });
        });
    } catch (e) {
      dispatch({ type: "SIGN_IN_ERROR", payload: e });
    }
  };
};

export const signInAnonymously = (creds) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    firebase
      .auth()
      .signInAnonymously()
      .then((value) => {
        console.log(value);
        dispatch({ type: "SIGN_IN" });
      })
      .catch((err) => {
        dispatch({ type: "SIGN_IN_ANON_ERROR", payload: err });
      });
  };
};

export const signUp = (profile) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    try {
      dispatch(StartLoadingAuth());
      const firebase = getFirebase();
      const firestore = getFirestore();
      const susers = [];
      const regionalbusinesses = new Map();
      var selectedsuser = "";
      firestore
        .collection(systemUserCollection)
        .where("listOfBanks", "!=", [])
        .where("status", "==", 1)
        .where("disabled", "==", false)
        .where("systemAccountID", "==", profile.region)
        .orderBy("listOfBanks", "asc")
        .get()
        .then((users) => {
          if (users.size > 0) {
            users.forEach((ur) => {
              susers.push(ur.id);
              regionalbusinesses.set(ur.id, 0);
            });
            console.log("susers");
            console.log(susers);
            firestore
              .collection(businessCollection)
              .where("status", "==", 1)
              .where("region", "==", profile.region)
              .get()
              .then((businesses) => {
                businesses.forEach((bs) => {
                  if (regionalbusinesses.has(bs.data().system_user)) {
                    regionalbusinesses.set(
                      bs.data().system_user,
                      regionalbusinesses.get(bs.data().system_user) + 1
                    );
                  }
                });
                console.log("regionalbusinesses");
                console.log(regionalbusinesses);
                const temparray = Array.from(regionalbusinesses.keys());
                temparray.forEach((bus) => {
                  if (!susers.includes(bus)) {
                    regionalbusinesses.delete(bus);
                  }
                });
                const mapSorted = new Map(
                  [...regionalbusinesses.entries()].sort((a, b) => a[1] - b[1])
                );
                console.log("mapSorted");
                console.log(mapSorted);
                if (mapSorted.size > 0) {
                  selectedsuser = Array.from(mapSorted.keys())[0];
                  console.log("selectedsuser");
                  console.log(selectedsuser);
                  firebase
                    .auth()
                    .createUserWithEmailAndPassword(
                      profile.user_email,
                      profile.password
                    )
                    .then((res) => {
                      return firestore
                        .collection(businessCollection)
                        .doc(res.user.uid)
                        .set({
                          created_at: new Date(),
                          business_name: profile.business_name.trim(),
                          business_address: profile.business_address.trim(),
                          business_email: profile.business_email.trim(),
                          business_phone: profile.business_phone,
                          business_phone_2: profile.business_phone_2,
                          identifier: (
                            (Math.random() * 100000000) |
                            0
                          ).toString(),
                          region: profile.region,
                          rep_name: profile.rep_name.trim(),
                          bank_name: profile.bank_name,
                          bank_account: profile.bank_account,
                          system_user: selectedsuser,
                          status: 1,
                          balance: 0,
                          user_email: profile.user_email.trim(),
                        });
                    })
                    .then(() => {
                      dispatch({ type: "SIGN_UP" });
                    })
                    .catch((err) => {
                      dispatch({ type: "SIGN_UP_ERROR", payload: err });
                    });
                } else {
                  dispatch({
                    type: "SIGN_UP_ERROR",
                    payload: "No System User Found",
                  });
                }
              })
              .catch((err) => {
                dispatch({ type: "SIGN_UP_ERROR", payload: err });
              });
          } else {
            dispatch({
              type: "SIGN_UP_ERROR",
              payload: "We can't accept businesses",
            });
          }
        })
        .catch((err) => {
          dispatch({ type: "SIGN_UP_ERROR", payload: err });
        });
    } catch (e) {
      dispatch({ type: "SIGN_UP_ERROR", payload: e });
    }
  };
};

export const signOut = () => {
  return (dispatch, getState, { getFirebase }) => {
    try {
      dispatch(StartLoadingAuth());
      const firebase = getFirebase();
      firebase
        .auth()
        .signOut()
        .then(() => {
          dispatch({ type: "SIGN_OUT" });
        })
        .catch((err) => {
          dispatch({ type: "SIGN_OUT_ERROR", payload: err });
        });
    } catch (e) {
      dispatch({ type: "SIGN_OUT_ERROR", payload: e });
    }
  };
};

export const resetPassword = (email) => {
  return (dispatch, getState, { getFirebase }) => {
    dispatch(StartLoadingAuth());
    const firebase = getFirebase();
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        dispatch({ type: "RESET_PASSWORD" });
      })
      .catch((err) => {
        dispatch({ type: "RESET_PASSWORD_ERROR", payload: err });
      });
  };
};

export const deleteAnonUser = () => {
  return (dispatch, getState, { getFirebase }) => {
    try {
      dispatch(StartLoadingAuth());
      const firebase = getFirebase();
      var user = firebase.auth().currentUser;
      user
        .delete()
        .then(() => {
          dispatch({ type: "DELETE_ANON" });
        })
        .catch((e) => {
          dispatch({ type: "DELETE_ANON_ERROR", payload: e });
        });
    } catch (e) {
      dispatch({ type: "DELETE_ANON_ERROR", payload: e });
    }
  };
};

export const sendEmail = (email) => {
  return (dispatch, getState, { getFirebase }) => {
    // dispatch(StartLoadingAuth());
    const firebase = getFirebase();
    firebase
      .auth()
      .sendEmailVerification(email)
      .then(() => {
        dispatch({ type: "EMAIL_VERIFICATION" });
        console.log("email sent");
      })
      .catch((err) => {
        dispatch({ type: "EMAIL_VERIFICATION_ERROR", payload: err });
        console.log("email not sent");
      });
  };
};

export const StartLoadingAuth = () => {
  return {
    type: "LOADING_AUTH",
  };
};
